import { identity } from '@gplibraries/react/identity';

const { roles, groups } = identity;

export const appTilesConfig = {
  appTileSize: '160px',
  tiles: [
    {
      href: '/dealer_access/part_manager.php',
      title: 'Order Parts',
      icon: { glyph: 'nut-fill' },
      external: true,
      allowedRoles: [roles.CS_USER, roles.TM, roles.PARTS],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    // {
    //   href: '/dealer_access/applications/eservice/',
    //   external: true,
    //   title: 'E-Service',
    //   icon: { glyph: 'tools' },
    //   allowedRoles: [roles.CS_USER, roles.TM, roles.SERVICE],
    //   allowedGroups: [groups.ADMINS, groups.DEALERS]
    // },
    {
      href: '/dealer_access/applications/ewarranty',
      title: 'E-Warranty',
      external: true,
      icon: { glyph: 'card-checklist' },
      allowedRoles: [roles.CS_USER, roles.TM, roles.SERVICE, roles.WARRANTY],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    {
      href: '/dealer_access/warranty_reg.php',
      title: 'Warranty Registration',
      icon: { glyph: 'pencil-square' },
      external: true,
      allowedRoles: [roles.CS_USER, roles.TM, roles.WARRANTY, roles.SALES_MARKETING, roles.SERVICE, roles.WHOLEGOODS, roles.CREDIT],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    {
      href: 'https://ww2.e-billexpress.com/ebpp/GreatPlains/',
      title: 'Pay Invoice',
      external: true,
      icon: { glyph: 'credit-card' },
      allowedRoles: [roles.CS_USER, roles.TM, roles.CREDIT],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    {
      href: '/bulletins',
      title: 'Bulletins',
      icon: { glyph: 'pin-angle-fill' },
    },
    {
      href: '/dealer_access/applications/coopAdvertisingCreditRequest/',
      external: true,
      title: 'Submit Co-op',
      icon: { glyph: 'receipt-cutoff' },
      allowedRoles: [roles.CS_USER, roles.TM, roles.SALES_MARKETING, roles.CREDIT],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    // {
    //   href: '/',
    //   title: 'Rebate Request',
    //   icon: { src: ClipboardDollarIcon }
    // },
    {
      href: '/bargain-warehouse',
      title: 'Bargain Warehouse',
      icon: { glyph: 'shop' },
      allowedRoles: [roles.CS_USER, roles.TM, roles.SALES_MARKETING, roles.CREDIT, roles.WHOLEGOODS],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    // {
    //   href: '/',
    //   title: 'Contact Us',
    //   icon: { glyph: 'telephone-outbound' }
    // },
    {
      href: '/dealer_access/gold_medallion_status/',
      title: 'Gold Medallion Status',
      icon: { glyph: 'award' },
      external: true,
      allowedRoles: [roles.CS_USER, roles.TM, roles.SALES_MARKETING, roles.CREDIT],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },
    {
      href: 'https://na3.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=675545b0-61de-47bb-8f78-c92f02cad352&env=na3-eu1&acct=ec056792-8648-471e-9706-d4cf432be94d',
      external: true,
      title: 'Cash Discount Claim Form',
      icon: { glyph: 'file-earmark-text' },
      allowedRoles: [roles.CS_USER, roles.TM, roles.SALES_MARKETING, roles.CREDIT, roles.WHOLEGOODS],
      allowedGroups: [groups.ADMINS, groups.DEALERS]
    },

  ]

}